<mat-form-field appearance="fill" class="fitWidth">
    <mat-label>{{'Parameter'  | translate: [transportOption.parameterNameDictionaryKey, translationService.language]}}</mat-label>
    <input matInput [required]="true" [disabled]="true" [value]="valueString">
    <button mat-icon-button matSuffix (click)="showSelectionDialog()"><mat-icon><sc-icon iconClass="fa-plus"></sc-icon></mat-icon></button>
</mat-form-field>